import type { MountProps } from '@ingka-group-digital/mfe-types';

let _isMfe = false;
let _mountProps: MountProps | null = null;

/** Called once by Checka.mount — marks this module instance as running inside a host shell. */
export function setMfeMode(props: MountProps): void {
  _isMfe = true;
  _mountProps = props;
}

/** Returns true when the app is mounted as an MFE inside a host shell. */
export function isMfeMode(): boolean {
  return _isMfe;
}

export function getMfeMountProps(): MountProps {
  if (!_mountProps) {
    throw new Error(
      'MFE mount props are not available outside of MFE mode. Ensure setMfeMode() is called with the mount props when running as an MFE.'
    );
  }
  return _mountProps;
}
